import { BASE_API_URL } from "../../../../config/url"

export const RESETPASSWORD_DONE = 'RESETPASSWORD_DONE'

export const RESETPASSWORD_API_URL = `${BASE_API_URL}/onboarding/user/resetpassword`
export const RESETOLDPASSWORD_API_URL = `${BASE_API_URL}/onboarding/user/reset-old-password`
export const REACT_APP_UPLOAD_PATH = 'https://n8.poc.andaihub.com/webhook/add_vector_docs'